import { RootState } from "../index";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

const selectAppReducer = (state: RootState) => state;

export const selectSalesArchive = createDraftSafeSelector(
  selectAppReducer,
  (state) => state.dSalesArchive,
);

export const selectSalesArchiveFilters = createDraftSafeSelector(
  selectSalesArchive,
  (state) => state.filters,
);

export const selectSalesArchiveReceiptNumber = createDraftSafeSelector(
  selectSalesArchiveFilters,
  (state) => state?.receiptNumber || "",
);

export const selectSalesArchiveSalePublicId = createDraftSafeSelector(
  selectSalesArchiveFilters,
  (state) => state?.salePublicId || "",
);

export const selectSalesArchiveTableData = createDraftSafeSelector(
  selectSalesArchive,
  (state) => state.data,
);

export const selectSalesArchiveDetailItem = createDraftSafeSelector(
  selectSalesArchive,
  (state) => state.detailItem,
);

export const selectSalesArchivePagination = createDraftSafeSelector(
  selectSalesArchive,
  (state) => state.pagination,
);
